/**
 * Check if the current device is mobile
 * @returns {boolean} - True if mobile, false otherwise
 */
export const isMobile = () => {
	const isMobileWidth = window.innerWidth <= 768;

	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
	const isMobileUserAgent = mobileRegex.test(userAgent);

	return isMobileWidth || isMobileUserAgent;
};
